export default __webpack_public_path__ + "static/media/office2-afterB-2048w.cc4db73f.avif";